<template>
    <div class="flex items-center space-x-2">
        <Icon
            :name="iconName"
            class="w-3.5 h-3.5 text-gray-500"
        />
        <slot />
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        iconName: {
            type: String,
            required: true,
        },
    })
</script>
